import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, Upload, Phone } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t shadow-lg z-50">
      <div className="flex justify-around items-center py-2">

        {/* HOME */}
        <button
          onClick={() => navigate('/')}
          className={`flex flex-col items-center text-xs ${
            isActive('/') ? 'text-green-600' : 'text-gray-500'
          }`}
        >
          <Home className="h-5 w-5" />
          Home
        </button>

        {/* BUY */}
        <button
          onClick={() => navigate('/browse')}
          className={`flex flex-col items-center text-xs ${
            isActive('/browse') ? 'text-green-600' : 'text-gray-500'
          }`}
        >
          <ShoppingBag className="h-5 w-5" />
          Buy
        </button>

        {/* SELL */}
        <button
          onClick={() => navigate(user ? '/upload-vehicle' : '/login')}
          className="flex flex-col items-center text-xs text-gray-500"
        >
          <Upload className="h-5 w-5" />
          Sell
        </button>

        {/* CONTACT */}
        <button
          onClick={() => navigate('/contact')}
          className={`flex flex-col items-center text-xs ${
            isActive('/contact') ? 'text-green-600' : 'text-gray-500'
          }`}
        >
          <Phone className="h-5 w-5" />
          Contact
        </button>

      </div>
    </div>
  );
};

export default MobileBottomNav;